import React, { useContext, useState, useEffect } from 'react';
import { FlowContext } from '../../core/flow-engine';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './style.css';
import Heading from '../../components/Typography/Heading/Heading';
import PersonalInformationSection from '../../components/PersonalInformationSection/PersonalInformationSection';
import JointOwnerPISection from '../../components/PersonalInformationSection/JointOwnerPISection';
import MinorPISection from '../../components/PersonalInformationSection/MinorPISection';
import MaxedOutContributionsModal from '../../components/MaxedOutContributionsModal/MaxedOutContributionsModal';
import { accountTypes } from '../../flows/shared/utils';
import { setMaxedContributoryLimit } from '../../flows/contributory/util';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';
import ExistingAgreementsBlockModal from '../../components/ExistingAgreementModals/ExistingAgreementsBlockModal';
import { displayExistingAgreementBlockModal } from './util';

/* eslint-disable complexity */
const PersonalInformationScreen = () => {
  const { back, next, appState } = useContext(FlowContext);
  const {
    store: {
      accountType,
      chargeType = '',
      enabled,
      loadedData,
      existingAgreements
    }
  } = appState;

  // determines if customer has already maxed out contribution limits
  // sets flag to display modal if they have
  const [maxedOut, setMaxedOutLimits] = useState(false);
  useEffect(() => {
    if (accountType === accountTypes.CONTRIBUTORY && enabled) {
      setMaxedContributoryLimit(loadedData, setMaxedOutLimits);
    }
  }, []);

  // US661619 (COMPLIANCE) - block clients opening agreements that match an existing agreement
  const hasExistingAgree = existingAgreements && existingAgreements?.length > 0;

  return (
    <>
      <div className="container">
        <Heading text="Enter your personal information" />

        <PersonalInformationSection />
        {[accountTypes.JOINT].includes(accountType) && <JointOwnerPISection />}
        {[accountTypes.UGMAUTMA].includes(accountType) && <MinorPISection />}
      </div>

      <div className="btn-container">
        <MFBeaconButton
          id="personalInformationContinue"
          data-name={generateGeneralTestID(
            'PersonalInformation',
            'ContinueButton'
          )}
          className="continue-btn"
          variant="primary"
          size="normal"
          onClick={next()}
          label="Continue"
        />
        <MFBeaconButton
          id="personalInformationBack"
          data-name={generateGeneralTestID('PersonalInformation', 'BackButton')}
          variant="secondary"
          size="normal"
          className="beacon-button-margin-override"
          onClick={back()}
          label="Back"
        />
      </div>

      <PhoneNumber />

      {maxedOut && <MaxedOutContributionsModal appState={appState} />}

      {/* block account opening for Non Retirement Transfer and Individual/TOD existing agreement flag is true */}
      {displayExistingAgreementBlockModal(
        accountType,
        chargeType,
        hasExistingAgree,
        maxedOut
      ) && <ExistingAgreementsBlockModal />}

      <style jsx>{styles}</style>
    </>
  );
};
/* eslint-enable complexity */

export default PersonalInformationScreen;
